import { render, staticRenderFns } from "./IconChevronUpSmall.vue?vue&type=template&id=77699f60"
import script from "./IconChevronUpSmall.vue?vue&type=script&lang=js"
export * from "./IconChevronUpSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports